export enum EmployeeStatus {
  ENABLED = 'ENABLED',
  LOCKED = 'LOCKED',
  EXPIRED = 'EXPIRED'
}
